<!-- Hideo logo (provisional: a face with glasses and buck teeth), drawn with the main colour; same geometry as public/icons/logo.svg -->
<template>
  <svg viewBox="0 0 150 150" aria-hidden="true">
    <rect width="150" height="150" rx="34" style="fill: rgb(var(--brand))" />
    <g fill="none" stroke-linecap="round" style="stroke: rgb(var(--on-brand))">
      <circle cx="52" cy="62" r="20" stroke-width="8" />
      <circle cx="98" cy="62" r="20" stroke-width="8" />
      <path d="M72 60q3-5 6 0M32 58l-8-4M118 58l8-4" stroke-width="6" />
      <path d="M52 98q23 12 46 0" stroke-width="7" />
    </g>
    <g style="fill: rgb(var(--on-brand))">
      <circle cx="52" cy="64" r="6" />
      <circle cx="98" cy="64" r="6" />
      <rect x="62" y="101" width="12" height="18" rx="3" />
      <rect x="76" y="101" width="12" height="18" rx="3" />
    </g>
  </svg>
</template>
